import React from "react";
import { Typography, Container, Grid, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import img1 from "./assets/1.png";
import img2 from "./assets/2.png";
import img3 from "./assets/3.png";
import img4 from "./assets/4.png";
import img5 from "./assets/5.png";
import img6 from "./assets/6.png";
import img7 from "./assets/7.png";
import img8 from "./assets/8.png";
import img9 from "./assets/9.png";
import img10 from "./assets/10.png";

const Home = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

  return (
    <Container maxWidth="lg">
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom>
          The Multidisciplined Google Cloud Architect Guide
        </Typography>
        <Typography variant="body1">
          Best Practices Guide: Excelling as a Google Cloud Architect, Solution Architect, and Cloud Native Developer
        </Typography>
        <hr />
        <br />
        <br />
        <Typography variant="h5" component="h2" gutterBottom>
          <Grid container spacing={4}>
            {[
              { title: "Master the Core Technologies and Concepts", path: "/core" },
              { title: "Embrace Continuous Learning and Stay Updated", path: "/learning" },
              { title: "Develop a Strong Foundation in AI", path: "/ai-foundations" },
              { title: "Foster Collaboration and Communication", path: "/collaboration" },
              { title: "Implement Agile and DevOps Methodologies", path: "/agile" },
              { title: "Prioritize Security and Compliance", path: "/security" },
              { title: "Optimize Cost and Resource Management", path: "/cost" },
              { title: "Focus on Scalability and Performance", path: "/scalability" },
              { title: "Document and Share Knowledge", path: "/documentation" },
              { title: "Practice Innovation and Experimentation", path: "/innovation" },
            ].map((item, index) => (
              <Grid key={index} item xs={12} sm={6} md={4}>
                <Box mb={2}>
                  <Link to={item.path} style={{ textDecoration: "none" }}>
                    <img
                      src={images[index]}
                      alt={`Placeholder ${index + 1}`}
                      width="100%"
                      style={{ marginBottom: "1rem", borderRadius: "5px" }}
                    />
                    <Button variant="outlined" fullWidth>
                      {item.title}
                    </Button>
                  </Link>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Typography>
      </Box>
    </Container>
  );
};

export default Home;
